import React, { useState } from 'react';
import { Button, Checkbox, Icon } from '@innovationnorway/cl-react';
import { useTranslation } from 'react-i18next';
import ValueField from 'src/components/ValueField/ValueField';
import BrregCompanySearch from 'src/components/BrregCompanySearch/BrregCompanySearch';
import PhaseChangeCompanyCheck from '../../components/PhaseChangeCompanyCheck';
import { SivaPhase } from 'src/api/v2';

type Props = {
  phase: SivaPhase;
  selectedCompanyName?: string | undefined;
  orgNumber?: string;
  setOrgNumber: React.Dispatch<React.SetStateAction<string>>;
  setSelectedCompanyName: React.Dispatch<React.SetStateAction<string>>;
  setCompanyError: React.Dispatch<React.SetStateAction<boolean>>;
  showNoCompanyCheckbox: boolean;
};

const ConnectCompany: React.FC<Props> = ({
  phase,
  selectedCompanyName,
  orgNumber,
  setOrgNumber,
  setSelectedCompanyName,
  setCompanyError,
  showNoCompanyCheckbox,
}) => {
  const { t: tCommon } = useTranslation('common');
  const { t: tSiva } = useTranslation('siva');

  const [hasCompany, setHasCompany] = useState<boolean>(true);

  const selectedOrgNumber = React.useMemo(() => {
    if (orgNumber) {
      return orgNumber;
    }
    return '';
  }, [orgNumber]);

  return (
    <>
      {!selectedCompanyName && !orgNumber ? (
        <>
          <BrregCompanySearch
            // TODO: finn en bedre måte å markere at den ikke er valgfri i visse tilfeller, må da stoppe submit
            label={
              !showNoCompanyCheckbox
                ? `${tSiva('newCompany.brregSearch.search.label')}*`
                : tSiva('newCompany.brregSearch.search.label')
            }
            className="margin-top--2"
            disabled={!hasCompany}
            onSelect={({ organizationNumber, name }) => {
              setOrgNumber(organizationNumber);
              setSelectedCompanyName(name);
            }}
          />
          {showNoCompanyCheckbox && (
            <Checkbox
              label={tSiva('contract.edit.noCompany.text')}
              name="noCompany"
              value="false"
              checked={!hasCompany}
              onChange={(e) => {
                setOrgNumber('');
                setSelectedCompanyName('');
                setCompanyError(false);
                const { checked } = e.currentTarget;
                setHasCompany(!checked);
              }}
            />
          )}
        </>
      ) : (
        <div className="display--flex gap--2 margin-top--2">
          <ValueField
            label={tCommon('company')}
            value={
              <div className="display--flex gap--2 align-items--center">
                {selectedCompanyName}
                <Button
                  type="button"
                  icon
                  variant="tertiary"
                  aria-label={`${tCommon('edit')} ${tCommon('company').toLowerCase()}`}
                  onClick={() => {
                    setOrgNumber('');
                    setSelectedCompanyName('');
                    setCompanyError(false);
                  }}
                >
                  <Icon prefix="fasr" iconName="edit" />
                </Button>
              </div>
            }
          />
        </div>
      )}

      {selectedOrgNumber && phase && (
        <PhaseChangeCompanyCheck
          selectedPhase={phase}
          organizationNumber={selectedOrgNumber}
          setError={setCompanyError}
        />
      )}
    </>
  );
};

export default ConnectCompany;
